import { IconCopy } from "@/components/icons/IconCopy";
import React, { CSSProperties, ReactNode } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

interface Props {
  text: string | number;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
  role?: string;
  onClick?: () => void;
  classNameIcon?: string;
}

export function Copy(data: Props) {
  const {
    text,
    children,
    role = "button",
    onClick = () => {},
    className = "",
    ...props
  } = data;

  const dispatch = useDispatch();

  const copy = (text: string) => {
    if (text) {
      onClick();
      navigator?.clipboard?.writeText(text);
      toast.success("Sao chép thành công");
    }
  };

  return (
    <div
      {...props}
      onClick={() => copy(text?.toString())}
      role={role}
      className={`flex align-items-center gap-1 cursor-pointer ${className}`}
    >
      {children}
      <IconCopy width={24} height={24} />
    </div>
  );
}
